import React, { useCallback, useContext } from "react";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";
import { useTheme } from "styled-components";
// import Card from "../Card";
import Button from "../Button";
// import { Body } from "../Text";
// import Loading from "../Loading";
import AlertContext from "../../../context/alert/AlertContext";

// const DropTarget = styled(Flex)`
//   align-items: center;
//   justify-content: center;
//   padding: 1rem;
//   width: 100%;
//   border: dashed 2px ${({ theme }) => theme.secondary};
//   border-radius: ${({ theme }) => `${theme.borderRadius}px`};
//   position: relative;
//   div {
//     margin: 0;
//   }
//   svg {
//     margin-left: 1rem;
//     width: 70px;
//     height: auto;
//   }
//   &:hover {
//     cursor: pointer;
//     background-color: rgba(0, 0, 0, 0.05);
//   }
// `;

// const Container = styled(Flex)`
//   position: absolute;
//   z-index: 1000;
//   top: 0;
//   left: -5rem;
//   width: 12rem;
//   height: 12rem;
//   overflow: hidden;
//   justify-content: flex-end;
//   @keyframes expand {
//     0% {
//       margin-right: 0;
//       width: 5rem;
//       height: 3rem;
//     }

//     100% {
//       width: 12rem;
//       height: 12rem;
//     }
//   }

//   > div {
//     animation-name: expand;
//     animation-duration: 400ms;
//     border-color: ${({ theme }) => theme.secondary};
//     background-color: ${({ theme }) => theme.backgroundColor};
//     width: 12rem;
//     transform-origin: right;

//     > div {
//       width: 100%;
//       overflow: hidden;
//       display: flex;
//       transition: 200ms ease-in-out all;
//     }
//   }
// `;

const actions = ["readFile", "returnFile"];

const DataImport = React.forwardRef(
  (
    {
      action = "readFile",
      buttonLabel = "Import",
      showCard = false,
      onSubmit = async () =>
        console.error("[DataImport]: function 'onSubmit' is not defined."),
    },
    ref
  ) => {
    const theme = useTheme();
    // const [show, setShow] = useState(false);
    // const [readyToSave, setRTS] = useState(false);
    // const [stateFiles, setStateFiles] = useState([]);
    // const [isLoading, setLoading] = useState(false);

    const { showWarningAlert, showFailureAlert } = useContext(AlertContext);

    const onClick = useCallback(
      async (files) => {
        try {
          // setLoading(true);
          showWarningAlert("Importing Lines...");
          var reader = new FileReader();
          reader.onload = async (e) => {
            // Use reader.result
            switch (action) {
              case actions[0]:
                await onSubmit(reader.result);
                // setLoading(false);
                break;
              default:
                // setLoading(false);
                break;
            }
          };
          reader.readAsText(files[0]);
        } catch (error) {
          console.error(error);
          showFailureAlert(
            "Failed to import lines. Please check your file configuration."
          );
          // setLoading(false);
        }
      },
      [action, onSubmit, showFailureAlert, showWarningAlert]
    );

    const onDrop = useCallback(
      (files) => {
        // setStateFiles(files);
        onClick(files);
      },
      [onClick]
    );

    const { getRootProps, getInputProps } = useDropzone({
      onDrop,
      multiple: true,
    });

    // const onClick = useCallback(() => {
    //   if (showCard) return;
    // }, []);

    return (
      <>
        <Button
          iconName="faCloudArrowUp"
          color={theme.secondary}
          // onClick={() => {
          //   setShow(true);
          // }}
          {...getRootProps()}
        >
          {buttonLabel}
        </Button>
        {!showCard && <input {...getInputProps()} />}
      </>
    );
  }
);

DataImport.propTypes = {
  action: PropTypes.string,
  buttonLabel: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default DataImport;
